import { Constants } from '../../../../_common/platform/ts/Constants';
import { config } from '../config';

import { AppDispatcher as Dispatcher } from '../dispatcher/AppDispatcher';

import { Action, check } from './AppActions';
export { Action, check } from './AppActions';

import { IValuesCollection } from '../../../../_common/platform/ts/appTheme';
import { IURLQuery } from '../Interfaces';

import { DisplayMode } from '../stores/WorkspaceStore';

export module I {
    export interface WORKSPACE_VIEW_OPEN extends Action {
        id: number;
        tab: number | { tabIndex: number; tabTitle: string };
        widgetID: number;
        originTab: number;
        options: any;
        theme: IValuesCollection;
        query: IURLQuery;
    }

    export interface SET_WORKSPACE_PRESENTATION_MODE extends Action {
        tab: number;
        workspaceID: number;
        displayMode: DisplayMode;
        showGrid: boolean;
    }

    export interface IWorkspaceViewOpenOptions {
        distractFree?: boolean;
        drilldown?: boolean;
    }
}

function checkAppMode(appMode) {
    return config.APP_MODE ? true : appMode;
}

export class WorkspaceActions {
    public workspaceViewOpen(
        id: number,
        tab?: number | { tabIndex: number; tabTitle: string },
        widgetID?: number,
        options?: I.IWorkspaceViewOpenOptions,
        query?: IURLQuery,
        originTab?: number,
        theme?: IValuesCollection
        //retTabId?: any
    ) {
        this.dispatcher.handleViewAction<I.WORKSPACE_VIEW_OPEN>({
            actionType: Constants.WORKSPACE_VIEW_OPEN,

            id: id,
            tab: tab,
            widgetID: widgetID,
            query: query,
            originTab: originTab,
            options: options,
            theme: theme
            //retTabId
        });
    }

    public setWorkspacePresentationMode(tab: number, workspaceID: number, displayMode: DisplayMode, showGrid: boolean) {
        this.dispatcher.handleViewAction<I.SET_WORKSPACE_PRESENTATION_MODE>({
            actionType: Constants.SET_WORKSPACE_PRESENTATION_MODE,

            tab: tab,
            workspaceID: workspaceID,
            displayMode: displayMode,
            showGrid: showGrid
        });
    }

    constructor(private dispatcher: Dispatcher) {}

    public static get(dispatcher: Dispatcher) {
        return new WorkspaceActions(dispatcher);
    }
}
